"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DIAL_CODES = void 0;
var React = require("react");
// Fallback list for surfaces whose SSR state does not provide the full
// country-code resource. Dial codes are strings, never ints.
exports.DEFAULT_DIAL_CODES = [
    '852', '853', '86', '886', '1', '44', '61', '65', '81', '82',
    '33', '49', '60', '62', '63', '64', '66', '91', '971',
];
var toOption = function (code) {
    return typeof code === 'string' ? { dial_code: code } : code;
};
var optionLabel = function (it) {
    var name = it.displayName || it.name;
    return name ? name + " +" + it.dial_code : "+" + it.dial_code;
};
var wrapperStyle = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    flexShrink: 0,
    minWidth: 64,
    padding: '0 8px',
};
var selectStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer',
};
// Shared dial-code dropdown. The closed control shows only "+{code}" (no
// country name, no flag); country names remain in the option list for
// scanning. Required with a default of 852 (Hong Kong).
var CountryCodeSelect = function (props) {
    var value = props.value || '852';
    var options = (props.codes && props.codes.length ? props.codes : exports.DEFAULT_DIAL_CODES).map(toOption);
    if (!options.some(function (it) { return it.dial_code === value; })) {
        options.unshift({ dial_code: value });
    }
    return (React.createElement("span", { className: "c-forms__ccode", style: wrapperStyle },
        React.createElement("span", { "aria-hidden": "true" },
            "+",
            value),
        React.createElement("select", { id: props.id, style: selectStyle, value: value, onChange: function (e) { return props.onChange(e.target.value); }, disabled: props.disabled, required: true }, options.map(function (it, i) { return (React.createElement("option", { key: it.dial_code + "-" + i, value: it.dial_code }, optionLabel(it))); }))));
};
exports.default = CountryCodeSelect;
